'use strict';

import modalComputoTemplate from './computo-metrico.modal.html';
import modalComputoController from './computo-metrico.modal.controller';
import modalAnticipoTemplate from './verificacion-anticipo.modal.html';
import modalAnticipoController from './verificacion-anticipo.modal.controller';
import modalItemsNoCerradosTemplate from './items-no-cerrados.modal.html';
import modalItemsNoCerradosController from './items-no-cerrados.modal.controller';

import modalArchivoController from '../../proyectos/c-proyectos/items/archivo.modal.controller';
import modalArchivoTemplate from '../../proyectos/c-proyectos/items/archivo.modal.html';

class PlanillaProyectoController {
  constructor($scope, DataService, Modal, $state, $stateParams, Supervision, _, Storage, Util, $q, Flujos, apiUrl, Message,$log) {
    'ngInject';
    this.$scope = $scope;
    this.DataService = DataService;
    this.Modal = Modal;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.Supervision = Supervision;
    this._ = _;
    this.Storage = Storage;
    this.Util = Util;
    this.$q = $q;
    this.Flujos = Flujos;
    this.apiUrl = apiUrl;
    this.Message = Message;
    this.items_modulo = [];
    this.items_x = [];
    this.filtroItems = 'TODOS';
    this.$log=$log;
  }

  $onInit() {
    this.usuario = this.Storage.getUser();
    this.idSupervision = this.$stateParams.idSupervision;
    this.getTipoUnidades();
    this.getSupervision();
    // TODO enviar rol si el usuario tiene mas de un rol
    this.url = `supervisiones/${this.idSupervision}?rol=${this.Storage.get('rol').id_rol}`;

    this.$scope.$on('transicion_accion_ejecutada', () => {
      this.$state.go('mis-proyectos');
    });

    this.datosPrevios = {
    }
  }

  $onChanges() {
    this.$scope.$watch('$ctrl.filtroItems', () => {
      if (!this.supervision) {
        return;
      }
      this.mostrarItems();
    });
  }

  mostrarItems() {
    switch (this.filtroItems) {
      case 'COMPLETADOS':
        this.filtrarItems((item) => {
          return item.completado;
        });
        break;
      case 'INCOMPLETOS':
        this.filtrarItems((item) => {
          return !item.completado;
        });
        break;
      case 'PARA_ENVIAR':
        this.filtrarItems((item) => {
          return item.cantidad_actual_fis !== 0;
        });
        break;
      default:
        this.filtrarItems();
    }
  }

  getSupervision() {
    this.DataService.get(`supervisiones/${this.idSupervision}`)
    .then( response => {
      if (response) {
        this.supervision = this.verificarModificaciones(response.datos);
        this.$log.log('DATOS DE LA SUPERVISION====>' + JSON.stringify(this.supervision));
        if(this.supervision.proyecto.proyecto_historico) {
          this.supervision.proyecto.plazo_ampliacion_total = 0;
          for (let i in this.supervision.proyecto.proyecto_historico) {
            let version = this.supervision.proyecto.proyecto_historico[i];
            if (version.plazo_ampliacion) {
              this.supervision.proyecto.plazo_ampliacion_total += version.plazo_ampliacion.por_volumenes + version.plazo_ampliacion.por_compensacion;
            }
          }
        }
        this.asignarDatosProyecto();
        this.mostrarItems();
        this.Flujos.getAtributosPermitidos(this.supervision);
        this.Supervision.setUsuario(this.usuario);
        this.Supervision.setSupervision(this.supervision);

        this.esEditable = this.Supervision.esEditable('computos');
        this.esEtapaEdicion = this.supervision.estado_supervision === 'REGISTRO_PLANILLA';
        if (!this.esEtapaEdicion) {
          this.filtroItems = 'PARA_ENVIAR';
        }
        this.prepararBoletas();
        this.supervision.supervisiones_anteriores.map(supervision => {
          supervision.numero = this.Util.getNumeroOrdinal(supervision.nro_supervision);
        });
        const DESEMBOLSOS = this._.map(this.supervision.supervisiones_anteriores, 'desembolso');
        this.supervision.monto_desembolso_total = this.Util.sumar(DESEMBOLSOS);
        // Restar ultimo desembolso si es vista planilla actual
        if(this.supervision.supervisiones_anteriores && this.supervision.supervisiones_anteriores.length && this.supervision.supervisiones_anteriores.length==this.supervision.nro_supervision) {
          this.supervision.monto_desembolso_total = this.Util.restar(this.supervision.monto_desembolso_total, this.supervision.supervisiones_anteriores[this.supervision.supervisiones_anteriores.length-1].desembolso);
        }
        // sumar anticipo
        if(this.proyecto && this.proyecto.anticipo) {
          this.supervision.monto_desembolso_total = this.Util.sumar([this.supervision.monto_desembolso_total, this.proyecto.anticipo]);
        }
        // sumar porcentaje anticipo al avance financiero
        if(this.proyecto.porcentaje_anticipo) {
          this.supervision.porcentaje_avance_fin = this.Util.sumar([this.supervision.porcentaje_avance_fin, this.Util.dividir(this.Util.multiplicar([this.proyecto.anticipo,100]),this.proyecto.monto_total)]);
        }
        // Diferencia del monto contrato original o monto con modificacion
        if(this.supervision.proyecto.monto_contractual!=this.supervision.monto_total_contractual && this.supervision.monto_total_contractual)
        {
          this.supervision.monto_total_por_ejecutar=this.Util.restar(this.supervision.monto_total_contractual,this.supervision.monto_total_acumulado);
        }
        else {
          this.supervision.monto_total_por_ejecutar=this.Util.restar(this.supervision.proyecto.monto_contractual,this.supervision.monto_total_acumulado);          
        }

        this.verificarDeudas();
        this.verificarItemsNoCerrados();
        this.esTecnico = ['TECNICO_UPRE','RESP_DEPARTAMENTAL_UPRE','ENCAR_REGIONAL_UPRE'].indexOf(this.usuario.rol.nombre)>=0 && this.supervision.estado_actual.codigo=='REGISTRO_PLANILLA';

        this.validacion = {
          fecha_fin_min: new Date(this.supervision.fecha_inicio),
          fecha_creacion_min: new Date(this.supervision.fecha_inicio),
          fecha_max: new Date(this.supervision.proyecto.fecha_recepcion_definitiva),
        };

        if(this.supervision.porcentaje_avance_fis == 100) {
          this.errorRedondeo = this.Util.restar(this.supervision.proyecto.monto_total, this.Util.sumar([this.supervision.monto_desembolso_total,this.supervision.monto_total_actual_ejecutado]));
          if(this.proyecto && this.proyecto.anticipo && this.desembolso) {
            this.errorRedondeo = this.Util.sumar([this.errorRedondeo, this.desembolso.descuento]);
          }
          if(this.errorRedondeo < -1 || 1 < this.errorRedondeo) {
            this.errorRedondeo = 0;
          }
        }
        this.datosPrevios.plazo_ejecucion_definitivo = this.proyecto.plazo_ejecucion_definitivo;
      }
    });
  }

  verificarModificaciones(datos) {
    // TODO optimizar
    let cabecera = datos.modulos[0].items[0].item_historico;
    for (let i in datos.modulos) {
      let items = datos.modulos[i].items;
      for (let j in items) {
        let ij = items[j].item_historico.length;
        for (let k=cabecera.length; k>ij; k--) {
          items[j].item_historico.unshift({
            version: (cabecera[k-1].version - ij)
          });
        }
      }
    }

    if(datos.proyecto.proyecto_historico[0] && !datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto) {
      datos.proyecto.proyecto_historico[0].tipo_modificacion_proyecto = {
        nombre: 'Contrato Original'
      }
    }
    return datos;
  }

  asignarDatosProyecto() {
    this.proyecto = this.supervision.proyecto;
    if (this.proyecto.doc_especificaciones_tecnicas) {
      this.urlDescEspTecnicas = `${this.apiUrl}proyectos/${this.supervision.fid_proyecto}/doc/ET/descargar`;
    }
    if (this.supervision.version_proyecto) {
      this.urlDescPlanilla = `${this.apiUrl}proyectos/${this.supervision.fid_proyecto}/doc/PA_${this.supervision.nro_supervision}/descargar`;
      this.urlDescComputosResumen = `${this.apiUrl}proyectos/${this.supervision.fid_proyecto}/doc/CMR_${this.supervision.nro_supervision}/descargar`;
      this.urlDescComputosItem = `${this.apiUrl}proyectos/${this.supervision.fid_proyecto}/doc/CM_`;
    }
  }

  irComputo(item) {
    this.$state.go('computo-proyecto', {idSupervision: this.idSupervision, idItem: item.id_item});
  }

  mostrarComputo(item) {    
    this.Modal.show({
      template: modalComputoTemplate,
      controller: modalComputoController,
      size: 'xlg',
      data: {
        supervision: this.supervision,
        item: item,        
        modoVista: this.supervision.estado_actual.atributos['computos'] ? false : true
      }
    }).result.then( (modificados) => {
      if (!modificados) {
        return;
      }
      if (this.Supervision.esEditable('computos') && modificados.length > 0) {
        this.getSupervision();
      }
    }).catch( () => {});
  }

  getTipoUnidades() {
    this.DataService.get(`parametricas/UNIDAD`).then(response => {
      if (response) {
        this.unidades = response.datos.rows;
        this.unidades_obj = {};
        this.unidades.forEach( uni => {
          this.unidades_obj[uni.codigo] = uni;
        });
      }
    });
  }

  getMgColor(item) {
    if (item.total_acumulado_fis === item.cantidad) {
      return  'bl-success';
    }
    if (item.total_acumulado_fis === 0) {
      return  'bl-primary';
    }
    if (item.cantidad_actual_fis > 0) {
      return  'bl-info';
    }
    return  'bl-warning';
  }

  getTitle(item) {
    if (item.total_acumulado_fis === item.cantidad) {
      return  'Completado';
    }
    if (item.total_acumulado_fis ===  0) {
      return  'Sin avance';
    }
    if (item.cantidad_actual_fis > 0) {
      return  'Con avance';
    }
    return  'Con avance en anterior(es) planilla(s)';
  }

  // TODO obtener valores desde el backend
  calcularFechaAmpliada(fecha) {
    if(fecha && this.proyecto && this.proyecto.plazo_ampliacion) {
      fecha = new Date(fecha);
      fecha.setDate(fecha.getDate()+this.proyecto.plazo_ampliacion.por_volumenes+this.proyecto.plazo_ampliacion.por_compensacion);
    }
    return fecha;
  }

  filtrarItems(condicion = () => { return true }) {
    this.supervision.modulos.forEach( modulo => {
      modulo.items.forEach( item => {
        item.show = condicion(item);
      });
      modulo.show = this._.some(modulo.items, { show: true });
    });
    this.Supervision.setSupervision(this.supervision);
  }

  volverSupervisiones() {
    this.$state.go('avance-proyecto', { idProyecto: this.supervision.fid_proyecto, matricula: this.Storage.get('user').matricula });
  }

  verificarDeudas() {
    if (this.proyecto.anticipo === 0) {
      return;
    }
    const DESCUENTOS = this._.map(this.supervision.supervisiones_anteriores, 'descuento_anticipo');
    const TOTAL_DESCUENTOS = this.Util.sumar(DESCUENTOS);
    this.deudaAnticipo = this.Util.restar(this.proyecto.anticipo, TOTAL_DESCUENTOS);
    if (this.deudaAnticipo === 0) {
      return;
    }
    this.tieneDeudas = true;
    this.desembolso = this.Supervision.calcularDescuento(this.supervision.tipo_descuento_anticipo, this.supervision.monto_total_actual_ejecutado, this.deudaAnticipo, this.proyecto.porcentaje_anticipo);
  }

  verificarItemsNoCerrados() {
    const ITEMS = this.Supervision.getItems();
    this.itemsNoCerrados =  this._.filter(ITEMS, item => {
      return ((item.falta_ejecutar_fis === 0 && item.falta_ejecutar_fin !== 0) ||
      (item.ejecutar_porcentaje_fis === 0  && item.falta_ejecutar_fis > 0)) && item.estado !== 'CERRADO';
    });
  }

  verificarPlanilla() {
    let defer = this.$q.defer();
    if (this.Supervision.esEditable('tipo_descuento_anticipo')) {
      return this.verificarAnticipo(defer);
    }
    if (this.estaEnTecnico(defer)) {
      return this.verificarDatosParaTecnico(defer);
    }
    defer.resolve({confirmar: true});
    return defer.promise;
  }

  verificarAnticipo(defer) {
    this.$log.log('Veririca Avance en 0 ====')
    // if (!this.tieneAvances()) {
    //   this.Message.warning(`No tiene avances para enviar.`);
    //   return defer.promise;
    // }

    if (this.tieneAnticipo() && this.deudaAnticipo > 0) {
      const modalConfirmacion =  this.Modal.show({
        template: modalAnticipoTemplate,
        controller: modalAnticipoController,
        data: {
          supervision: this.supervision,
          deudaAnticipo: this.deudaAnticipo,
          errorRedondeo: this.errorRedondeo,
          esPlanillaCierre: this.supervision.porcentaje_avance_fis == 100
        },
        size: 'lg'
      });
      modalConfirmacion.result.then( () => {
          defer.resolve();
      }, () => { });
    } else {
      defer.resolve();
    }
    return defer.promise;
  }

  verificarDatosParaTecnico(defer) {
    if (this.itemsNoCerrados.length > 0) {
      const modalConfirmacion = this.Modal.show({
        template: modalItemsNoCerradosTemplate,
        controller: modalItemsNoCerradosController,
        data: {
          items: this.itemsNoCerrados,
          supervision: this.supervision,
        },
        size: 'lg'
      });
      modalConfirmacion.result.then( (aprobar) => {
        if (aprobar) {
          defer.resolve();
        }
      }, () => { });
    } else if (this.supervision.porcentaje_avance_fis === 100) {
      this.Modal.confirm(`Se le recuerda que ésta es la <strong>Planilla de Cierre</strong>.
        <p>¿Está seguro/a de aprobar la presente planilla, tomando en cuenta que con ella finalizará el registro de los avances del proyecto?</p>
        <p>En caso de estar seguro/a seleccione la opción <b>APROBAR</b>.</p>`, () => {
        defer.resolve();
      }, null,`Confirmación previa al cierre del proyecto`, 'APROBAR');
    } else {
      defer.resolve({confirmar: true});
    }
    return defer.promise;
  }

  tieneAnticipo() {
    return this.supervision.proyecto.porcentaje_anticipo > 0;
  }

  tieneAvances() {
    return this.supervision.monto_total_actual_ejecutado > 0;
  }

  estaEnTecnico() {
    return this.supervision.estado_supervision === 'EN_TECNICO';
  }

  irAtras() {
    window.history.back();
  }

  prepararBoletas() {
    this.boletasAnticipo = this.getBoletaPorTipo('TB_CORRECTA_INVERSION');
    this.boletasCcontrato = this.getBoletaPorTipo('TB_CUMPLIMIENTO_CONTRATO');
  }

  getBoletaPorTipo(tipo) {
    let fecha = this.supervision.fecha_fin? new Date(this.supervision.fecha_fin): new Date();
    return this._.filter(this.supervision.proyecto.boletas, boleta => {
      let f2 = new Date(boleta.fecha_fin_validez);
      if (f2<fecha) {
        boleta.class = boleta.estado=='ACTIVO'? 'bg-warning': 'text-warning';
      }
      return boleta.tipo_boleta === tipo; // && boleta.estado==='ACTIVO';
    });
  }

  getTipoClass(tipo_modificacion) {
    if (tipo_modificacion=='TM_CONTRATO_MODIFICATORIO') return 'cmodificatorio';
    if (tipo_modificacion=='TM_ORDEN_CAMBIO') return 'orden-cambio';
    if (tipo_modificacion=='TM_ORDEN_TRABAJO') return 'orden-trabajo';
    return '';
  }

  verPdfInforme(codigo) {
    if(codigo && (codigo=='ITCS'||codigo=='ITCF')) {
      let datos = {
        codigo: `${codigo}_${this.supervision.nro_supervision}`,
        titulo: `Documento Informe Técnico`
      };
      this.Modal.showDocumentBase64(`proyectos/${this.supervision.fid_proyecto}/doc/${codigo}_${this.supervision.nro_supervision}`, datos.titulo);
    }
  }

  cargarPdfInforme(codigo) {
    if(codigo && (codigo=='ITCS'||codigo=='ITCF')) {
      let titulo = `Documento Informe Técnico`;
      const confArchivo = {
        formatos: 'pdf',
        tipos: '.pdf'
      };
      this.mostrarModal(titulo, 'fa-upload', confArchivo, modalArchivoTemplate, modalArchivoController, 'Cargar documento')
      .result.then( docEspecificaciones => {
        if (angular.isUndefined(docEspecificaciones)) {
          return;
        }
        let datos = {};
        datos.documento = docEspecificaciones;
        this.DataService.put(`proyectos/${this.supervision.fid_proyecto}/doc/${codigo}_${this.supervision.nro_supervision}/subir`, datos).then(result => {
          if (result && result.finalizado) {
            this.Message.success(`Se registró el documento correctamente.`);
            if(codigo==='ITCS')this.supervision.informe_doc=true;
            if(codigo==='ITCF')this.supervision.informe_fiscal_doc=true;
          }
        });
      });
    }
  }
  // Modal
  mostrarModal(titulo, icon, data, template, controller, labelOk, size) {
    return  this.Modal.show({
      template: template,
      controller: controller,
      data: data || {},
      title: titulo,
      icon: icon,
      size: size?size:'md',
      labelOk: labelOk
    });
  }

  cRedondeo(obj) {
    if(typeof(obj.c_redondeo)==='undefined') {
      obj.c_redondeo = '';
    }
    let data = {
      cRedondeo:obj.c_redondeo
    };
    this.DataService.put(`computos_metricos/items/${obj.id_item}`,data).then((resp)=>{
      if (resp&&resp.finalizado) {
        if (this.Supervision.esEditable('computos')) {
          this.getSupervision();
        }
      } else {
        obj.c_redondeo = '';
      }
    });
  }

  agregarQuitarCampo() {
    let data = {
      c_redondeo: !this.supervision.c_redondeo
    };
    this.DataService.put(`supervisiones/${this.supervision.id_supervision}/campo_regularizacion`, data).then((resp)=>{
      if (resp&&resp.finalizado) {
        this.supervision.c_redondeo = true;
      } else {
        this.supervision.c_redondeo = false;
      }
    });
  }

  guardarPlazoDefinitivo() {
    if (this.proyecto.plazo_ejecucion_definitivo==this.datosPrevios.plazo_ejecucion_definitivo) {
      return;
    }
    let datos = {
      estado_proyecto: 'APROBADO',
      plazo_ejecucion_definitivo: this.proyecto.plazo_ejecucion_definitivo
    }
    this.DataService.put(`proyectos/${this.supervision.fid_proyecto}/plazo-definitivo/${this.supervision.id_supervision}`, datos).then((resp)=>{
      if (resp && resp.finalizado) {
        let f = new Date(this.proyecto.fecha_recepcion_definitiva);
        f.setDate(f.getDate() + (this.proyecto.plazo_ejecucion_definitivo-this.datosPrevios.plazo_ejecucion_definitivo));
        this.proyecto.fecha_recepcion_definitiva = f;
        this.datosPrevios.plazo_ejecucion_definitivo = this.proyecto.plazo_ejecucion_definitivo;
        this.Message.success(resp.mensaje);
      } else {
        this.proyecto.plazo_ejecucion_definitivo = this.datosPrevios.plazo_ejecucion_definitivo;
      }
    });
  }

}

export default PlanillaProyectoController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/planilla-proyecto/planilla-proyecto.controller.js